import React from 'react'
import { withTranslation } from 'react-i18next'
import * as UIcons from '@iconscout/react-unicons'
import DetailDrawer from '../../shared/DetailDrawer'

export default withTranslation()(function ContactDetailDrawer({ t, contact, onClose, onEdit, onDeactivate, onDelete }) {
  const isActive = (contact.status ?? 'active') !== 'inactive'

  const typeLabel = contact.contact_type
    ? t(`settings.business_organization.contact_person.types.${contact.contact_type}`)
    : t('settings.business_organization.contact_person.primary_contact')

  const fields = [
    { label: t('settings.business_organization.contact_person.columns.name'), value: `${contact.first_name ?? ''} ${contact.last_name ?? ''}`.trim() },
    { label: t('settings.business_organization.contact_person.columns.email'), value: contact.email },
    { label: t('settings.business_organization.contact_person.columns.type'), value: typeLabel },
    { label: t('settings.business_organization.contact_person.form.phone.label'), value: contact.phone }
  ]

  return (
    <DetailDrawer
      title={t('settings.business_organization.contact_person.drawer_title')}
      onClose={onClose}
      footer={
        contact.isPrimary ? null : (
          <>
            <button
              type="button"
              onClick={onEdit}
              className="flex-1 h-10 rounded-full border border-border-lines text-dark-blue font-medium flex items-center justify-center gap-1.5"
            >
              <UIcons.UilEditAlt size={16} /> {t('settings.business_organization.contact_person.edit')}
            </button>

            <button
              type="button"
              onClick={onDeactivate}
              className="flex-1 h-10 rounded-full border border-gold text-gold font-medium flex items-center justify-center gap-1.5"
            >
              <UIcons.UilBan size={16} /> {isActive ? t('settings.business_organization.contact_person.deactivate') : t('settings.business_organization.contact_person.enable')}
            </button>

            <button
              type="button"
              onClick={onDelete}
              className="flex-1 h-10 rounded-full border border-danger text-danger font-medium flex items-center justify-center gap-1.5"
            >
              <UIcons.UilTrash size={16} /> {t('settings.business_organization.contact_person.delete')}
            </button>
          </>
        )
      }
    >
      <div className="divide-y divide-border-lines">
        {
          fields.map(({ label, value }) => (
            <div key={label} className="py-4">
              <p className="text-sm text-secondary mb-1">{label}</p>
              <p className="text-dark-blue font-medium">{value || '—'}</p>
            </div>
          ))
        }
      </div>
    </DetailDrawer>
  )
})
